<template>
    <div class="m-x-3-lg m-x-2-md m-y-2-md">

        <span class="titulo-seccion">Principios del Manejo Ecológico Integral de Arvenses (MEIA)</span>
        <h1 class="titulo">Artículos científicos</h1>

        <div class="contenedor-documentos">
          <DownloadFile
            file="descargables/articulos/Bajwa et al. 2015 Nonconventional weed managemente strategies.pdf" 
            type="appdivcation/pdf" 
            format="PDF" 
            name="Nonconventional Weed Management Strategies for Modern Agriculture" 
            downloadname="Bajwa et al. 2015 Nonconventional weed managemente strategies.pdf" 
            weight="3.9 MB" 
            cover="descargables/articulos/cover/weed.png" />

          <DownloadFile
            file="descargables/articulos/Colbach et al. 2020 The pitfalls of relating weeds.pdf" 
            type="appdivcation/pdf" 
            format="PDF" 
            name="The Pitfalls of Relating Weeds, Herbicide Use, and Crop Yield: Don’t Fall Into…" 
            downloadname="The Pitfalls of Relating Weeds, Herbicide Use, and Crop Yield: Don’t Fall Into….pdf" 
            weight="3.9 MB" 
            cover="descargables/articulos/cover/Colbach et al. 2020 The pitfalls of relating weeds.png" />

          <DownloadFile
            file="descargables/articulos/Fernandez O. 1982. Manejo integrado de malezas.pdf" 
            type="appdivcation/pdf" 
            format="PDF" 
            name="Manejo integrado de malezas" 
            downloadname="Manejo integrado de malezas.pdf" 
            weight="3.9 MB" 
            cover="descargables/articulos/cover/Manejo integrado de malezas.png" />

          <DownloadFile
            file="descargables/articulos/MacLaren et al 2020 An ecological future for weed science.pdf" 
            type="appdivcation/pdf" 
            format="PDF" 
            name="An ecological future for weed science to sustain crop production and the…" 
            downloadname="An ecological future for weed science to sustain crop production and the….pdf" 
            weight="3.9 MB" 
            cover="descargables/articulos/cover/An ecological future for weed science to sustain crop production and the….png" />


        </div>

        <h2 class="subtitulo m-t-2">Enlaces</h2>
        <p>
            A continuación, encontrarás la cita y el enlace para acceder a otros artículos relacionados
            con el Manejo Ecológico Integrado de Plagas. Estos enlaces se actualizan conforme se encuentren
            nuevos artículos pertinentes al tema.
        </p>
        <div class="listado-enlaces">
            <div class="bullet-enlaces"> <ArrowRight class="arrow-r"/>
                <p>Beckie, H. J., Flower, K. C., & Ashworth, M. B. (2020). Farming without Glyphosate?. Plants 
                (Basel, Switzerland), 9(1), 96. <a href="https://doi.org/10.3390/plants9010096">https://doi.org/10.3390/plants9010096</a></p>
            </div>
            <div class="bullet-enlaces"> <ArrowRight class="arrow-r"/>
                    <p>Böcker, T., Britz, W., Möhring, N., Finger, R. (2020) An economic and environmental assessment 
                of a glyphosate ban for the example of maize production, European Review of Agricultural 
                Economics, 47(2), 371–402, <a href="https://doi.org/10.1093/erae/jby050">https://doi.org/10.1093/erae/jby050</a></p>
            </div>
            <div class="bullet-enlaces"> <ArrowRight class="arrow-r"/>
                    <p>Chikowo, R., Faloya, V., Petit, S. & Munier-Jolain, N. M. (2009). Integrated Weed Management 
                systems allow reduced redivance on herbicides and long-term weed control. Agriculture, Ecosystems 
                & Environment 132(3–4) 237-242 <a href="https://doi.org/10.1016/j.agee.2009.04.009">https://doi.org/10.1016/j.agee.2009.04.009</a></p>
            </div>
            <div class="bullet-enlaces"> <ArrowRight class="arrow-r"/>
                    <p> Malkanthi, S.H.P., Sandareka, U.G., Wijerathne, A.W. and Sivashankar, P., 2019. Banning of 
                Glyphosate and its Impact on Paddy Cultivation: A study in Ratnapura District in Sri Lanka. 
                Journal of Agricultural Sciences – Sri Lanka, 14(2), pp.129–144. DOI: <a href="http://doi.org/10.4038/jas.v14i2.8515">http://doi.org/10.4038/jas.v14i2.8515</a></p>
            </div>
            <div class="bullet-enlaces"> <ArrowRight class="arrow-r"/>
                    <p>Marambe, B., & Herath, S. (2020). Banning of herbicides and the impact on agriculture: The case of glyphosate in 
                Sri Lanka. Weed Science, 68(3), 246-252. doi:10.1017/wsc.2019.71 <a href="https://bit.ly/3nPUn9W">https://bit.ly/3nPUn9W</a></p>
            </div>
            <div class="bullet-enlaces"> <ArrowRight class="arrow-r"/>
                    <p>Petit, S., Munier-Jolain, N., Bretagnolle, V. et al. (2015) Ecological Intensification Through 
                Pesticide Reduction: Weed Control, Weed Biodiversity and Sustainabidivty in Arable Farming. 
                Environmental Management 56, 1078–1090 . <a href="https://doi.org/10.1007/s00267-015-0554-5">https://doi.org/10.1007/s00267-015-0554-5</a></p>
            </div>
        </div>
    </div>
</template>

<script>
import DownloadFile from '@/components/DownloadFile.vue'
import ArrowRight from 'vue-material-design-icons/ArrowRightCircle.vue'

export default {
  name: 'PrincipiosArvensesArticulos',
  components: {
      ArrowRight,
      DownloadFile
  },
  mounted() {
    this.$store.commit('setTemaAlternativa', 'Principios del Manejo Ecológico Integral de Arvenses (MEIA)');
    this.$store.commit('setSubtemaAlternativa', 'Artículos científicos');
  }
}
</script>

<style lang="scss">
.listado-enlaces {
    font-size: map-get($fuente , "size-secundario" ) ;
    font-weight: lighter;

    .bullet-enlaces {
        display: flex;
        flex-direction: row;
        padding: 15px 0;
    }
    .bullet-enlaces .arrow-r {
        color: #1F5D50 !important;
        margin-right: 15px;
    }
    .bullet-enlaces p {
        margin: 0;
        font-size: map-get($fuente , "size-primario" );
    }
    .bullet-enlaces p a:hover {
        background-color: transparent;
        color: $verde-obscuro;
    }
}
</style>
